import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconHourglassHigh } from "@tabler/icons-react";


export const FrecuenciaActIcon = IconHourglassHigh;
export const FrecuenciaActHelpText = '* Aquí se pueden ver las frecuencias de actualización aplicables.';

export class catFrecuenciaAct extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "FrecuenciaAct";
        this.def.columns.c_category_id.defaultValue = "FrecuenciaAct";
        this.Title = "Frecuencias de actualización";
        this.HelpText = FrecuenciaActHelpText;
        this.Icon = FrecuenciaActIcon;
    }
}